import { useSelector } from 'react-redux';
import './App.css';
// import WhatsApp from './assets/WhatsApp.svg';
import MainRoute from './MainRoute';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from 'react';

function App() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
const isDarkMode = useSelector((state) => state.theme.isDarkMode);

  // const openWhatsApp = () => {
  //   const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  //   window.open(url, "_blank");
  // };
  document
    .querySelector("html")
    .setAttribute("dir", currentLocal.language === "English" ? "ltr" : "rtl");
useEffect(() => {
  if (isDarkMode) {
    document.body.classList.add('dark-theme');
  } else {
    document.body.classList.remove('dark-theme');
  }
}, [isDarkMode]);
// useEffect(() => {
//     const handleContextmenu = (e) => {
//       e.preventDefault(); // يمنع ظهور القائمة عند الضغط كليك يمين
//     };
//     document.addEventListener('contextmenu', handleContextmenu);
//     return () => {
//       document.removeEventListener('contextmenu', handleContextmenu);
//     };
//   }, []);
  return (
<div className={ currentLocal.language ==="English" ?'App':"ar_app"}>
      <MainRoute />
      <ToastContainer />

      {/* <button
        onClick={openWhatsApp}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#25D366",
          color: "white",
          border: "none",
          padding: "10px 12px",
          borderRadius: "50%",
          fontSize: "18px",
          cursor: "pointer",
          boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
        }}
      >
        <img src={WhatsApp} alt='WhatsApp'
          style={{
            width: "25px"
          }}
        />
      </button> */}
    </div>

  );
}

export default App;
